module.exports = __webpack_public_path__ + "static/media/ic_align_right.5a317938.svg";